import { Box, BoxProps } from '@mui/material';
import React from 'react';

const CenterContentBox: React.FC<BoxProps> = props => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Box display="flex" alignItems="center" justifyContent="center" {...props} />
);

export default CenterContentBox;
